import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';


import { PracticeArea } from './parea';

@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.css']
})
export class PracticeComponent implements OnInit {
  practiceArea: PracticeArea;
  currArea: string;
  areaMap = {
    'infoarch': 'Information Architecture',
    'iot': 'IOT',
    'cloud': 'Cloud Computing',
    'security': 'Security',
    'strategy': 'Strategy',
    'archservs': 'Architecture Services',
    'ls_parea': 'Life Sciences'
  };
  getKeys = function (input: Object) {
    return Object.keys(input);
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {
    router.events.subscribe((val) => {
      this.getArea();
    });
  }

  async ngOnInit() {
    this.getArea();
  }

  async getArea() {
    let area = null;
    await this.route.params.subscribe(params => area = params['area']);
    if (area === undefined || area === null) {
      // TODO: Error handling if no area
    }
    this.currArea = area;
    if (area === 'overview') {
      return;
    }
    const filepath = 'assets/json/pareas/' + area + '.json';
    await this.http.get(filepath)
      .subscribe(
        res => {
          this.practiceArea = res as PracticeArea;
          // console.log(res);
        },
        err => {
          // TODO: Error handling stuff
          console.log(err);
        },
      );

  }
}
